import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Route, withRouter } from 'react-router-dom';
import myProfileActions from '../../store/my-profile/action-creators';
import ChangePassword from './ChangePassword';
import MyProfileDetail from './MyProfileDetail';

class MyProfileContainer extends Component {
  // ----------------------
  // Lifecycle
  // ----------------------

  componentDidMount() {
    this.props.fetchMyProfile();
  }

  render() {
    return (
      <Fragment>
        <Route component={ChangePassword} path="/my-profile/change-password" />
        <Route component={MyProfileDetail} exact path="/my-profile" />
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapDispatchToProps = (dispatch) => {
  return {
    fetchMyProfile: () => {
      return dispatch(myProfileActions.fetchMyProfile());
    },
  };
};

export default withRouter(connect(null, mapDispatchToProps)(MyProfileContainer));
